/* eslint-disable */

export const enum DashboardTileCategory {
  news = 1,
  produktupdate = 2,
  seminar = 3,
  webinar = 4,
  whitepaper = 5,
  blog = 6,
  newsletter = 7,
  aktuelles = 8,
  kundenevent = 9,
  messe = 10,
  stoerung = 11,
  video = 12,
  backup = 13,
  wissen = 14,
}
